'use client';
import { Box, Stack } from '@mui/material';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import { ArrowLeftIcon, ArrowRightIcon } from '@components/SVGIcon/Icons';
import { Mobile } from '@components/Mobile';
import { Desktop } from '@components/Desktop';
import SplideSlider from '@components/SplideSlider';
import CustomImage from '@components/CustomImage';
import cn from './style.module.scss';
export default function OgamiShowcase(props: MarketingPageComponentProps) {
  const showcaseSection = props?.locale?.section?.find(
    (section: any) => section.type === 'showcase' && section.enabled
  );
  if (!showcaseSection) return null;
  const ogamiShowcaseSliderElement = showcaseSection?.ogamiShowcaseSlider || [];
  const ogamiShowcaseSlideSettings = {
    type: 'fade',
    rewind: true,
    autoplay: true,
    speed: 2000,
    interval: 6000,
  };
  return (
    <Stack component="section" className={cn.ogamiShowcaseWrapper}>
      <Box className={cn.ogamiShowcaseInner}>
        <Box className={cn.ogamiShowcaseBlock}>
          <SplideSlider
            showArrows
            arrowsClassName={cn.ogamiBannerArrows}
            prevClassName={cn.ogamiBannerPrev}
            nextClassName={cn.ogamiBannerNext}
            prevArrow={<ArrowLeftIcon />}
            nextArrow={<ArrowRightIcon />}
            options={ogamiShowcaseSlideSettings}
          >
            {ogamiShowcaseSliderElement.map((item: any, index: number) => (
              <Box key={item.url ?? index} className={cn.ogamiBannerStory}>
                <Mobile>
                  <CustomImage
                    src={item.mobileUrl}
                    alt={item.alt ?? `slider-image-${index}`}
                    width={800}
                    height={1200}
                  />
                </Mobile>
                <Desktop>
                  <CustomImage
                    src={item.url}
                    alt={item.alt ?? `slider-image-${index}`}
                    width={1200}
                    height={800}
                  />
                </Desktop>
              </Box>
            ))}
          </SplideSlider>
        </Box>
      </Box>
    </Stack>
  );
}
